<template>
    <form @submit.prevent="submitForm">
        <field-text required v-model="form.title" label="عنوان" placeholder=""/>
        <field-upload required v-model="form.download_link"
                      :link=" action + '/upload'"
                      label="فایل" placeholder="" class="browse-fa"/>
        <alert :success="success" :danger="danger"></alert>


        <button-delete title="حذف" class="float-left"
            :link="action"
            @deleted="itemDeleted"
            v-show="edit" :id="edit"/>

            <button-submit title="ثبت"/>
    </form>
</template>

<script>
    import ButtonSubmit from "../ButtonSubmit";
    import Alert from "../Alert";
    import FieldPassword from "../fields/FieldPassword";
    import FieldMobile from "../fields/FieldMobile";
    import FieldEmail from "../fields/FieldEmail";

    import mixinForm from "../../mixins/mixinForm";
    import FieldSelect from "../fields/FieldSelect";
    import FieldText from "../fields/FieldText";
    import FieldUpload from "../fields/FieldUpload";
    import ButtonDelete from "../ButtonDelete";

    export default {
        mixins: [mixinForm],
        components: {
            ButtonDelete,
            FieldUpload,
            FieldSelect,
            FieldText,
            FieldEmail,
            FieldMobile,
            FieldPassword,
            Alert,
            ButtonSubmit,
        },
        name: "FormCategoryFile",
        props: ['action'],
        methods:{
            itemDeleted(){
                this.$emit('deleted')
            }
        }
    }
</script>
<style>
    .custom-file-input ~ .custom-file-label::after {
        content: "انتخاب";
    }


</style>


// WEBPACK FOOTER //
// src/components/forms/FormCategoryFile.vue